//https://mailtrap.io/blog/validate-emails-in-react/#Method-two-email-validation-with-React-Hook-Form-library
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
